import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../../components/BreadCrumbs/BreadCrumbs';
import Page from '../../../../components/Page/Page';
import { SETTINGS } from '../../../../routes/routeConstants';
import DeleteAccount from './DeleteAccount';

const AccountManagement = () => {
  const { pathname } = useLocation();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Settings`,
        link: `/${SETTINGS}`,
      },
      {
        name: `Account Management`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Account Management'>
      <Container>
        <BreadCrumbs pathData={pathArr as any} hideOnWeb />
        <FormHeaderLabel>Account Management</FormHeaderLabel>
        <DeleteAccount />
      </Container>
    </Page>
  );
};

export default AccountManagement;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormHeaderLabel = styled.div`
  display: flex;
  font-size: 22px;
  line-height: 22px;
  font-weight: 600;
`;
